import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { authStore } from '@/stores';
import { ColorVariants } from '@/constants';
import { reactive } from 'vue';
import _ from 'lodash';
import { goToLogin } from '@/utils';
import { useRouter } from 'vue-router';

export interface Expose {
  check: () => Promise<boolean>
}

interface Props {
  className?: string;
}

  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    className: { default: 'dialog-campaign dialog-campaign-check' }
  },
  setup(__props: any, { expose }) {



const dialog = reactive({
  login: false,
  email: false,
  address: false,
});

function closeDialog(dialogName?: string) {
if (dialogName) {
  dialog[dialogName] = false;
} else {
  _.forEach(dialog, (val, key) => {
    if (val) {
      dialog[key] = false;
    }
  });
}
}

function showDialog(dialogName: string) {
  closeDialog();
  dialog[dialogName] = true;
}

function login() {
  closeDialog();
  goToLogin();
}

const router = useRouter();
function verify() {
  closeDialog();
  router.push({ name: 'mine.memberProfile.edit', query: { type: 'email' } });
};

function navToProfileEdit() {
  closeDialog();
  router.push({ name: 'mine.memberProfile.edit' });
};

const check = async () => {
  if (!authStore.isLogin) {
    showDialog('login');
    return false;
  }
  await authStore.tryFetchData();
  const emailVerified = _.get(authStore, 'user.profile.email_verified');
  if (!emailVerified) {
    showDialog('email');
    return false;
  }
  if (!authStore.canParticipateProgram) {
    showDialog('address');
    return false;
  }
  return true;
};

expose<Expose>({
  check
});

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).login,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialog).login) = $event)),
      class: _normalizeClass([__props.className]),
      btns: [
        { text: '로그인', style: _unref(ColorVariants).primary, click: login }
      ],
      content: "로그인 해주세요"
    }, null, 8, ["visible", "class", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).email,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(dialog).email) = $event)),
      class: _normalizeClass([__props.className]),
      btns: [
        { text: '이메일 인증하기', style: _unref(ColorVariants).primary, click: verify }
      ],
      content: "이메일 인증이 필요합니다."
    }, null, 8, ["visible", "class", "btns"]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialog).address,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_unref(dialog).address) = $event)),
      class: _normalizeClass([__props.className]),
      btns: [
        { text: '확인', style: _unref(ColorVariants).primary, click: navToProfileEdit }
      ],
      content: "마이페이지에서 주소 및 휴대폰 번호를 확인해주세요"
    }, null, 8, ["visible", "class", "btns"])
  ]))
}
}

})